import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function logsService() {
  const api = useApi()

  function getLogs(params) {
    return api.query(`${URLS.logs}${params || '/'}`)
  }

  function getLogsById(id) {
    return api.query(`${URLS.logs}/${id}/`)
  }

  return {
    getLogsById,
    getLogs,
    ...api,
  }
}
